import apiDict from '@/api/gate/apiDict'
import * as attachApi from '@/api/gate/attach/index'
const Base64 = require('js-base64').Base64; // 引入
export default {
  data() {
    return {
    }
  },
  methods: {
    /*
    查询门户字典
    参数：key
    */
    async mixFeignDictDataList(key) {
      let  res = await apiDict['getFeginDictData']({ dictCode: key })
      const body = res && res.body ? res.body : {}
      const list = body.dictDataList || []
      const values = list.map(e => ({ label: e.dataName, value: e.dataCode}))
      return values
    },
   /*
    查询行政区域树
    参数：pcode
    */
    async mixFeignAreaCodeTree(pcode) {
      let res = await apiDict['getAreaCodeTree']({pcode:pcode})
      const body = res && res.body ? res.body : {}
      const list = body.areaList || []
      return list
    },
    /*
    查询行政区域列表
    参数：pcode
    */
    async mixFeigAreaCodeList(pcode) {
      let res = await apiDict['getAreaCodeList']({pcode:pcode})
      const body = res && res.body ? res.body : {}
      const list = body.areaList || []
      return list
    },
    /*
    从缓存中查询基础数据字典
    参数：key 自定义字典名dic开头
    参数：api 查询指定业务表的api
    参数：dataName 中文名称
    参数：dataCode 编码
    */
    async mixBaseDictDataList(key,api,dataName,dataCode) {
      const params = {
        key : key,
        api : api,
        dataName : dataName,
        dataCode : dataCode,
      }
      const resList = await this.$store.dispatch('getBaseDictDataList', params)
      return resList
    },
   /*
    获取指定数组对象的数据字典中文名称，用于页面显示
    参数：key,code
    */
    mixFeignLookUpDict(dict,code){
      let label  = ""
      if (dict && dict.length > 0) {
        dict.forEach((item) => {
          if(item.value == code){
            label = item.label
          }
        })
     }
     return label
    },
    /*
    获取指定数组对象的数据字典编码，用于关键词搜索
    参数：key,label
    */
    mixFeignDictCode(dict,label){
      let code  = ""
      if (dict && dict.length > 0) {
        dict.forEach((item) => {
          if(item.label == label){
            code = item.value
          }
        })
     }
     return code
    },
    /**文件下载 */ 
    downloadFile(file){
      if (file) {
        window.location.href = $config.downloadUrl + encodeURIComponent(file.filePath)
      }
    },
    /***文件预览 */
    previewFile(file){
      if (file) {
        window.open(this.getPreviewUrl(file))   
      }
    },
   /**获取文件预览路径 */
    getPreviewUrl(file){
    if (file) {
      var source =  $config.rootUrl + file.filePath
      var url =  Base64.encode(source) //base64编码
      if(url.length > 0){
        return   $config.kkFileViewUrl + encodeURIComponent(url)
      }
    }
  },
     /***文件删除 */
    deleteFile(fileList) {
      if(fileList && fileList.length > 0){
        fileList.map((item) => {
          var filePath = item.filePath
          if(filePath && filePath!=''){
            attachApi.deleteUploadFile({ filePath: filePath })
            console.log('删除服务器文件成功',filePath)
          }
        })
      }
    },
    deleteFileWithHistory(oldFiles,attachments,removeFiles){
      this.deleteFileCompare(oldFiles,removeFiles)//判断待删除文件是否在oldFiles里面=》不能删除
      // this.deleteFileCompare(oldFiles,attachments)//判断是否有已上传，但是没有记录的文件，要进行删除
    },
    deleteFileCompare(oldVal,newVal){
      let deleteFile = []
      if(newVal && newVal.length > 0){
        newVal.forEach((e1)=>{
          let updateFlag = false 
          if(oldVal && oldVal.length > 0){
            oldVal.forEach((e2)=>{
              if(e1.filePath == e2.filePath){
                updateFlag = true
              }
            })
          }
          if(!updateFlag){
            deleteFile.push(e1);
          }
        })
      }
      if(deleteFile && deleteFile.length > 0){
       this.deleteFile(deleteFile) //删除多余文件
      }
    },
    //封装删除附件记录的函数
    deleteAllAttachmentPromise(attach) {
      return new Promise((resolve, reject) => {
        attachApi.deleteAttachment(attach.id).then(res => {
          let success = res && res.success ? res.success : null
          if(!success){
              let data = res && res.data ? res.data : {}
              success = data && data.success ? data.success : null
          }
          if (success) {
            resolve();
           
          } else reject();
        })
        .catch(() => {
          reject();
         })
      });
    },
    /***附件记录更新 */
    async mixFeignUpdateAttachments(objectId,objectNamespace,attachments){
      const params = {
        objectId: objectId,
        objectNamespace: objectNamespace
      }
      const res = await attachApi.getAttachmentList(params)
      let body = res && res.body ? res.body : null
      if(!body){
          let data = res && res.data ? res.data : {}
          body = data && data.body ? data.body : {}
      }
      const list = body.list || []
      let deleteFunc = [];
      list.map(attach => { //循环遍历旧的附件记录，删除记录
          deleteFunc.push(
            this.deleteAllAttachmentPromise(attach)
          )
      });
      if(deleteFunc.length>0){
        Promise.all(deleteFunc)
        .then(() => {
            console.log('删除旧附件记录',list)
            this.saveAttach(objectId,objectNamespace,attachments) //保存新的附件记录
        })
        .catch(() => {
            console.log('删除旧附件记录失败',list)
        });
      }else{
        this.saveAttach(objectId,objectNamespace,attachments) //保存新的附件记录
      }
     

    },
    async saveAttach(objectId,objectNamespace,attachments){
      attachments.map(async e => {
        const info = {
          attachName: e.attachName,
          attachType: e.attachType,
          filePath: e.filePath,
          objectId: objectId,
          objectNamespace: objectNamespace,
          attachSize: e.attachSize
      }
        await attachApi.saveAttachment(info)
          .then(res => {
            console.log("res",res)
            let success = res && res.success ? res.success : null
            if(!success){
                let data = res && res.data ? res.data : {}
                success = data && data.success ? data.success : null
            }
            if (success) {
              console.log('保存附件记录成功',info)
            }else{
              console.log('保存附件记录失败',info)
            }
          })
          .catch(() => {
              console.log('保存附件记录失败',info)
          })
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js